import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    toast.error("Payment was cancelled.");
    navigate("/subscribe", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center p-4">
      <div className="animate-pulse text-muted-foreground">Redirecting...</div>
    </div>
  );
};

export default PaymentCancelPage;
